import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import MetaTags from '../components/seo/MetaTags';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <MetaTags
        title="404 - Page Not Found | DiversiCoin"
        description="The page you're looking for doesn't exist."
        url="https://www.DiversiCoin.cash/404"
      />
      <div className="text-center px-4">
        <h1 className="text-6xl font-bold text-white mb-4">404</h1>
        <p className="text-xl text-gray-300 mb-8">Page not found</p>
        <Link
          to="/"
          className="inline-flex items-center space-x-2 bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg transition-colors"
        >
          <Home className="w-5 h-5" />
          <span>Back to Home</span>
        </Link>
      </div>
    </div>
  );
}